import React, { useEffect, useState } from 'react';
import { Stack, Drawer } from '@mui/material';
import ReducedNewsCard from './ReducedNewsCard';
import ExpandedNews from '../../Expanded/ExpandedNews';
import { ContributeBias } from './InjectedReducedCard';
import {Helmet} from "react-helmet";

const ReducedView = ({ news, doInject }) => {

    const [drawerData, setDrawerData] = useState(null)
    const [prevUrl, setPrevUrl] = useState('')
    const [displayLayout, setDisplayLayout] = useState([])

    const openDrawer = (data) => {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?open='+data.id;
        window.history.pushState({ path: newurl }, '', newurl);
        setDrawerData(data)
    }
    
    useEffect(()=>{
        setPrevUrl(window.location.href)
        window.addEventListener('popstate', function(event) {
            setDrawerData(null)
            var newurl = window.location.protocol + "//" + window.location.host;
            window.history.pushState({ path: newurl }, '', newurl);
        }, false);
    },[])

    useEffect(()=>{
        const randPlace = Math.floor(Math.random()*15)
        const copy = [...news]
        if(doInject){
            copy.splice(randPlace,1,"contribute")
            setDisplayLayout(copy)
        }else{
            setDisplayLayout(copy)
        }
    },[news])

    const closeDrawer= ()=>{
        setDrawerData(null)
        var newurl = window.location.protocol + "//" + window.location.host;
        window.history.pushState({ path: newurl }, '', newurl);
    }


    return (
        <Stack spacing={2} style={{ margin: 0, width: '100%' }}>
            <Helmet>
                <title>Читај! - Сѐ ново на едно место</title>
                <meta name="description" content="Читај ефикасно" />
            </Helmet>
            {displayLayout.map(el =>
            {
                if(el=="contribute"){
                    return <ContributeBias key={el}/>
                }else{
                    return <ReducedNewsCard news={el} key={el.title} clickEv={()=>openDrawer(el)}></ReducedNewsCard>
                }
            }
            )}
            <Drawer
                variant="temporary"
                anchor='right'
                open={drawerData!=null}
                onClose={()=>closeDrawer()}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                PaperProps={{
                    sx: {
                      backgroundColor: "#1B2430",
                    }}}
                sx={{
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '80%'},
                }}
            >
                {drawerData ? <ExpandedNews news={drawerData}/> : ''}
            </Drawer>
        </Stack>
    )
}

export default ReducedView;